import { Component } from '@angular/core';

@Component({
	selector: 'course-license-expired-error-renderer',
	templateUrl: './course-license-expired-error.component.html',
	styleUrls: ['./course-license-expired-error.component.scss'],
	standalone: false
})
export class CourseLicenseExpiredErrorComponent {}
